import './SankeyCanvas.css';
export var canvasContainer = '_1hfx9ue0-3-15-1';
export var highlightCanvas = '_1hfx9ue1-3-15-1';